class GenericExporter {
	getName() {
		return 'Download Text';
	}

	getDescription() {
		return 'Saves the raw text without transforming it in any way.';
	}

	getFileType() {
		return '.txt';
	}

	getMimeType() {
		return 'text/plain';
	}

	export(text) {
		return Promise.resolve(text);
	}
}

export default GenericExporter;


// WEBPACK FOOTER //
// ./src/exporters/generic.js